<mat-form-field [appearance]="appearance" [subscriptSizing]="subscriptSizing" [class]="fieldClass" [class.compact]="compact">
  <mat-label *ngIf="!compact">{{ label }}</mat-label>
  <input
    matInput
    [attr.aria-label]="label"
    [matDatepicker]="picker"
    [formControl]="control"
    [placeholder]="placeholder"
    [required]="isRequired"
    [min]="min"
    [max]="max"
    (dateChange)="commitValue($event.value)"
    (keydown)="commitBeforeNavigation($event)"
    (blur)="markAsTouched()" />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [touchUi]="touchUi || ((isMobile$ | async) ?? false)" [calendarHeaderComponent]="calendarHeaderComponent"></mat-datepicker>

  <mat-error *ngIf="hasError('required')">{{ getErrorMessage('required') }}</mat-error>
  <mat-error *ngIf="hasError('beforeBirthDate')">{{ getErrorMessage('beforeBirthDate') }}</mat-error>
  <mat-error *ngIf="hasError('futureBirthDate') && !hasError('matDatepickerMax')">{{ getErrorMessage('futureBirthDate') }}</mat-error>
  <mat-error *ngIf="hasError('matDatepickerMin')">{{ getErrorMessage('matDatepickerMin') }}</mat-error>
  <mat-error *ngIf="hasError('matDatepickerMax')">{{ getErrorMessage('matDatepickerMax') }}</mat-error>
  <mat-error *ngIf="hasError('matDatepickerParse')">{{ getErrorMessage('matDatepickerParse') }}</mat-error>
</mat-form-field>
